import { createSlice } from '@reduxjs/toolkit';

const initialState = {

  investment_statements: null,
  investment_details: null,
  client_holdings: null
};


export const fundInvestmentSlice = createSlice({
  name: 'fundInvestment',
  initialState,
  reducers: {
    setInvestmentLoading: (state, action) => {
      state.investment_loading = action.payload;
    },
    setInvestmentStatement: (state, action) => {
      state.investment_statements = action.payload;
    },
    setInvestmentDetails: (state, action) => {
      state.investment_details = action.payload;
    },
    setClientHoldings: (state, action) => {
      state.client_holdings = action.payload;
    },
  },
});

export const {
  setInvestmentLoading,
  setInvestmentStatement,
  setInvestmentDetails,
  setClientHoldings
} = fundInvestmentSlice.actions;

export default fundInvestmentSlice.reducer;
